// src/components/Programs/HowProgramWorks.jsx

const HowProgramdetailWorks = ({ data }) => {
  if (!data) return null;

  const { heading = "How the Program Works", image, imageAlt, steps = [] } = data;

  return (
    <section className="w-full py-10 md:py-14 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="ava-heading-md text-center  mb-8 md:mb-10">
          {heading}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-[1.1fr_0.9fr] overflow-hidden rounded-l-[var(--ava-radius-md)] ava-card-bg ava-card-mukta ava-radius-md">
          {/* Left: Image */}
          <div className="h-full  ava-radius-md ">
            <img
              src={
                image ||
                "https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=1100&q=80 "
              }
              alt={imageAlt || "Program steps"}
              className="w-full h-full object-cover min-h-[260px] "
              loading="lazy"
            />
          </div>

          {/* Right: Steps */}
          <div className="ava-card-bg p-4 md:p-4 flex flex-col justify-center gap-8">
            {steps.map((step) => (
              <div key={step.id} className="flex items-start gap-3 ps-8">
                <span className="w-8 h-8 shrink-0 rounded-full bg-[var(--primary-color)] text-white ava-text-sm flex items-center justify-center">
                  {step.number}
                </span>
                <div>
                  <h3 className=" ava-text-subheading">
                    {step.title}
                  </h3>
                  <p className="ava-text-body">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowProgramdetailWorks;